import { render, staticRenderFns } from "./service_order_page.vue?vue&type=template&id=05d0f44c&scoped=true"
import script from "./service_order_page.vue?vue&type=script&lang=js"
export * from "./service_order_page.vue?vue&type=script&lang=js"
import style0 from "./service_order_page.vue?vue&type=style&index=0&id=05d0f44c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0f44c",
  null
  
)

export default component.exports